var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5123_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 20.7001L28.4708 13.9277H27.0594L21.8897 19.8142L17.7632 13.9277H13L19.2435 22.825L13 29.9277H14.4113L19.8725 23.7184L24.2368 29.9277H29L22.5264 20.7001H22.5187ZM20.5858 22.9L19.9569 22.0141L14.9252 14.9639H17.0959L21.1611 20.6551L21.79 21.5411L27.0748 28.9367H24.9041L20.5935 22.9H20.5858Z",
    fill: "#F9F5EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21 41.7578C32.0457 41.7578 41 32.8035 41 21.7578C41 10.7121 32.0457 1.75781 21 1.75781C9.9543 1.75781 1 10.7121 1 21.7578C1 32.8035 9.9543 41.7578 21 41.7578Z",
    stroke: "#F9F5EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5123_1694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXicon);
export default __webpack_public_path__ + "static/media/xicon.da27d11663bf0b990abccee51ac02750.svg";
export { ForwardRef as ReactComponent };